export interface UserSummary {
  id: string;
  email: string;
  signup_date: string;
  last_sign_in_at: string | null;
  banned_until: string | null;
  email_confirmed_at: string | null;
  display_name: string | null;
  username: string | null;
  avatar_url: string | null;
  city: string | null;
  state: string | null;
  premium_override: boolean | null;
  premium_override_expires_at: string | null;
  onboarding_completed_at: string | null;
  events_hosted: number;
  events_attended: number;
  has_active_subscription?: boolean;
  // Canonical user_entitlements columns from admin_search_users; the
  // has_active_subscription flag above does not check current_period_end.
  entitlement_tier?: string | null;
  entitlement_status?: string | null;
  entitlement_platform?: string | null;
  entitlement_period_end?: string | null;
}

export interface UserDetail {
  id: string;
  email: string;
  created_at: string;
  last_sign_in_at: string | null;
  banned_until: string | null;
  email_confirmed_at: string | null;
  profile: {
    display_name: string | null;
    username: string | null;
    avatar_url: string | null;
    bio: string | null;
    city: string | null;
    state: string | null;
    experience_level: string | null;
    riding_style: string | null;
    ride_frequency: string | null;
    premium_override: boolean | null;
    premium_override_expires_at: string | null;
    onboarding_completed_at: string | null;
    instagram_handle: string | null;
    tiktok_handle: string | null;
    first_name: string | null;
    gender: string | null;
  };
  stats: {
    events_hosted: number;
    events_attended: number;
    chat_messages: number;
    ratings_given: number;
    ratings_received: number;
    friends: number;
    vehicles: number;
    achievements: number;
    reports_against: number;
  };
  recent_events: Array<{ id: string; title: string; meetup_time: string; status: string; city: string; state: string }>;
  recent_participation: Array<{ id: string; title: string; meetup_time: string; rsvp_status: string; checked_in_at: string | null }>;
  premium_history?: Array<{ created_at: string; admin_email: string; enabled: string; duration_months: string | null; expires_at: string | null }>;
  subscription?: { product_id: string; status: string; auto_renew_status: boolean; purchase_date: string; expires_date: string; renewal_date: string | null; environment: string; last_notification_type: string | null; updated_at: string } | null;
  // Store-paid entitlement from the user_entitlements-derived admin read-back
  // (admin_search_users). admin_get_user_detail itself does not return it.
  entitlement?: {
    tier: string | null;
    status: string | null;
    platform: string | null;
    period_end: string | null;
  } | null;
  // True when the entitlement read-back failed or returned no row — the Admin
  // UI must show "unavailable" rather than guessing paid status.
  entitlement_unavailable?: boolean;
  // True when a post-mutation or explicit refresh failed — the last-known
  // status is stale and must not be presented as current.
  status_stale?: boolean;
}

export interface UserStats {
  total_users: number;
  suspended_users: number;
  premium_users: number;
  new_today: number;
  new_this_week: number;
  onboarded: number;
}

export const SUSPEND_DURATIONS = [
  { value: '24h', label: '24 Hours' },
  { value: '7d', label: '7 Days' },
  { value: '30d', label: '30 Days' },
  { value: '90d', label: '90 Days' },
  { value: 'permanent', label: 'Permanent' },
];

